module.exports = __webpack_public_path__ + "static/media/quartz_101.68fba05b.ico";